module.exports = __webpack_public_path__ + "static/media/bg.ba02e8f5.png";